import React from 'react';
import Skeleton from '@material-ui/lab/Skeleton';
import { Grid } from "@material-ui/core";

function SkeletonLoader() {
    return (
        <div>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={3}>
                    <Skeleton height={25} variant="rect" />
                </Grid>
                <Grid item xs={12} sm={3}>
                    <Skeleton height={25} variant="rect" />
                </Grid>
                <Grid item xs={12} sm={3}>
                    <Skeleton height={25} variant="rect" />
                </Grid>
                <Grid item xs={12} sm={3}>
                    <Skeleton height={25} variant="rect" />
                </Grid>
                <Grid item xs={12} sm={3}>
                    <Skeleton height={25} variant="rect" />
                </Grid>
                <Grid item xs={12} sm={3}>
                    <Skeleton height={25} variant="rect" />
                </Grid>
                <Grid item xs={12} sm={3}>
                    <Skeleton height={25} variant="rect" />
                </Grid>
                <Grid item xs={12} sm={3}>
                    <Skeleton height={25} variant="rect" />
                </Grid>
                <Grid item xs={12} sm={3}>
                    <Skeleton height={25} variant="rect" />
                </Grid>
                <Grid item xs={12} sm={3}>
                    <Skeleton height={25} variant="rect" />
                </Grid>
                <Grid item xs={12} sm={3}>
                    <Skeleton height={25} variant="rect" />
                </Grid>
                <Grid item xs={12} sm={3}>
                    <Skeleton height={25} variant="rect" />
                </Grid>
                <Grid item xs={12} sm={3}>
                    <Skeleton height={25} variant="rect" />
                </Grid>
                <Grid item xs={12} sm={3}>
                    <Skeleton height={25} variant="rect" />
                </Grid>
                <Grid item xs={12} sm={3}>
                    <Skeleton height={25} variant="rect" />
                </Grid>
                <Grid item xs={12} sm={3}>
                    <Skeleton height={25} variant="rect" />
                </Grid>
            </Grid>
        </div>
    )
}

export default SkeletonLoader;
